<template>
  <div>
    <tax-return-delivery-dialog
      v-if="currentTaxReturn && currentCompany"
      :key="currentTaxReturn.id"
      :opened.sync="reviewTaxReturnDialogOpened"
      :currentCompanyId="currentCompany.id"
      :taxReturnId="currentTaxReturn.id"
    />
  </div>
</template>

<script>
import API from '@/api';
import TaxReturnDeliveryDialog from '@/components/returns/TaxReturnDeliveryDialog';

export default {
  components: {
    TaxReturnDeliveryDialog,
  },

  data() {
    return {
      currentTaxReturn: null,
      currentCompany: null,
      reviewTaxReturnDialogOpened: true,
    };
  },

  computed: {
    taxReturnId() {
      return this.$route.params.id;
    },

    currentCompanyId() {
      return this.$route.query.companyId;
    },
  },

  methods: {
    async getCurrentCompany() {
      const response = await API.company.getCompany(this.currentCompanyId);
      this.currentCompany = response.data;
    },

    async getTaxReturn() {
      const response = await API.taxReturn.getTaxReturn({
        id: this.taxReturnId,
        companyId: this.currentCompanyId,
      });

      this.currentTaxReturn = response.data;
    },
  },

  async created() {
    this.getCurrentCompany();
    this.getTaxReturn();
  },
};
</script>

<style></style>
